

export class TourStatusInput implements ITourStatusInput {
    /** The auto-generated id of the tour master */
    tourId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ITourStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourId = _data["tourId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TourStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new TourStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourId"] = this.tourId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITourStatusInput {
    /** The auto-generated id of the tour master */
    tourId: number;
    /** The updated status */
    status: number;
}

